import axios from "axios";
import Config from "src/config";

const v3_actionGeneratePrompts = (clientId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v3/${clientId}/ai/generate-prompt`,
        data: data
        });
};

export default v3_actionGeneratePrompts;
